<div #divSupplierChild>
    <supplier-registration-form #supplierChild  class="block" 
    *ngIf="!isSubmitSucceededEvent"
    [SupplierIdInput] = "selectedSupplierId"
    [CategoryIdInput] ="categoryId"
    [IsInActivateStepInput]="isInActivateStepInput">
    </supplier-registration-form >
  </div>

  <div *ngIf="!isRequestHistory" #divPurchasingApprovalChild>
    <supplier-registration-aproval #purchasingApprovalChild
    (isSubmitSucceededEvent)="receiveIsSubmitSucceededEvent($event)"
    [ApprovalLevelInput]="approvalLevel"
    [WFAppInstanceIDInput]= "wfAppInstanceId"
    [SupplierIdInput]= "selectedSupplierId">
    </supplier-registration-aproval>  
  </div>